import React from "react";

export function PageHeader({ title, subtitle, children, testid }) {
  return (
    <div className="flex flex-col items-start justify-between gap-4 border-b border-slate-800 px-4 pb-5 pt-5 stat-grid-bg sm:px-6 lg:flex-row lg:items-end lg:px-8 lg:pt-8 lg:pb-6" data-testid={testid}>
      <div className="min-w-0">
        <h1 className="text-2xl font-extrabold tracking-tight text-white md:text-4xl">{title}</h1>
        {subtitle && <p className="text-sm text-slate-400 mt-2 max-w-xl">{subtitle}</p>}
      </div>
      <div className="flex w-full flex-wrap items-center gap-2 lg:w-auto lg:justify-end">{children}</div>
    </div>
  );
}

export function PageContent({ children }) {
  return <div className="space-y-6 p-4 sm:p-6 lg:p-8">{children}</div>;
}
